/* eslint-disable */
import { completeWithInfo } from "./complete";

import {
  CmsDocumentSituationRatingApiModel,
  CmsDocumentVectorSearchApiModel,
  RatingApiModel,
} from "api-models";

import SmartSearchResult from "./smart-search-result";
import getEmbedding from "./get-embedding";
import axios from "axios";
import { CmsDocumentTypes } from "services/cms/cms-type-configuration";

let wordRatings = {
  completely: -0.75, // completely irrelevant
  irrelevant: -0.5,
  unrelated: -0.25,

  largely: 0.25, // largely irrelevant/not relevant
  not: 0.25, //not directly

  indirectly: 1,

  less: 1.5,

  only: 2, // only somewhat
  tang: 2.5, //tangentially.

  slightly: 2.25,

  somewhat: 2.75,
  still: 2.75,
  partially: 3.25,
  likely: 3.25,

  related: 3.5,
  generally: 3.75,

  relevant: 4,

  quite: 4.25, //quite relevant.
  very: 4.5,
  directly: 4.75, // wonder if directly should be on a par or higher than "highly", or lower?
  highly: 5,
  strongly: 5.25,
  particularly: 5.5,
  extremely: 5.75,
  exceptionally: 5.75,
  incredibly: 6,

  pertinent: 8,
  yes: 10,
  no: 0,
};

export { wordRatings };

let getPrompt = (query: string, line: string) => `${line}

How relevant is the article to '${query}'?

The article is`;

async function massRate(query: string, embeddingCuttoff: number) {
  query = query.replace(/jyre/gi, "");
  let embedding = await getEmbedding(query);
  //let situationsP: Promise<Situation[]> = await (await axios.get("/journal/getsituations")).data;

  let situationRatings = (
    await axios.post("/api/cmsdocumentsituations", {
      embedding: embedding,
      count: embeddingCuttoff,
      excludeTags: [
        "_ExcludeFromSearch",
        "_DELETED",
        window.location.hostname == "app.gyreteams.com" ? "_HideInLive" : "XXNonExistentTag",
      ],
      includeTypes: [
        "cms-pathway",
        "cms-personal-pathway",
        "cms-session-with-slides",
        "cms-resource",
      ] as CmsDocumentTypes[],
    } as CmsDocumentVectorSearchApiModel)
  ).data as CmsDocumentSituationRatingApiModel[]; // situationsJson as Situation[]; //await situationsP;

  let results = situationRatings.map((s, i) => {
    return {
      situation: s.situation,
      ratings: {
        embedding: s.rating,
        embeddingIndex: i,
        tokenProbs: {},
        logProbWords: -1,
        logProbWordsIndex: 0,
      },
      justification: "",
      story: "",
      storyTitle: "",
      keyPoints: [],
      showInfo: false,
    } as SmartSearchResult;
  });

  results.sort((a, b) => b.ratings.embedding - a.ratings.embedding);
  results.forEach((x, i) => (x.ratings.embeddingIndex = i));
  let ratings = await rateWords(
    results.slice(0, embeddingCuttoff).map((r) => {
      let line = r.situation.relevanceSummary.replace(
        "This article",
        `The article "${r.situation.title}"`,
      );
      return getPrompt(query, line);
    }),
  );

  for (let i = 0; i < ratings.length; i++) {
    results[i].ratings.logProbWords = ratings[i].rating;
    results[i].ratings.tokenProbs = ratings[i].logProbs;
  }

  results.sort((a, b) => b.ratings.logProbWords - a.ratings.logProbWords);
  results.forEach((x, i) => (x.ratings.logProbWordsIndex = i));

  return results;
}

async function rateWords(prompts: string[]) {
  let infos = await completeWithInfo(
    prompts.map((prompt) => ({
      prompt,
      token_bias: { " of": -100 },
      temperature: 0,
      presence_penalty: 0,
      frequency_penalty: 0,
      max_tokens: 1,
      logprobs: 5,
    })),
  );

  return infos.map((c) => {
    let logProbs = c.result.choices[0].logprobs!.top_logprobs![0];

    let rating = Object.keys(logProbs).reduce(
      (sum, word) =>
        (wordRatings[word.trim().toLowerCase()] === undefined
          ? 0
          : Math.exp(logProbs[word]) * wordRatings[word.trim().toLowerCase()]) + sum,
      0,
    );

    let total = Object.keys(logProbs).reduce(
      (sum, word) =>
        (wordRatings[word.trim().toLowerCase()] === undefined ? 0 : Math.exp(logProbs[word])) + sum,
      0,
    );

    return { rating: rating / total, logProbs: logProbs };
  });
}

export { rateWords, massRate };
